import { type ReactNode } from 'react';
import type { Approacher } from '../types';
import { ArchivedActions, ViewActions } from './approacher-detail-actions';
import {
  ArchiveBar,
  RestoreBar,
  StreakResetBar,
} from './approacher-detail-confirm-bars';
import { ResetConfirmBar, ResetReveal } from './password-reset-bars';
import { StatusEditBar } from './status-edit-bar';
import { VerificationPhotoBar } from './verification-photo-bar';
import { VacationBar } from './vacation-bar';
import type { DetailMode } from './approacher-detail-view';

export type FooterProps = {
  a: Approacher;
  mode: DetailMode;
  tempPwd: string;
  onEdit: () => void;
  onArchive: () => void;
  onRestore: () => void;
  onReset: () => void;
  onStreakReset: () => void;
  onUploadPhoto: () => void;
  onVacation: () => void;
  onCancel: () => void;
  onConfirmArchive: () => void;
  onConfirmRestore: () => void;
  onConfirmReset: () => void;
  onConfirmStreakReset: () => void;
  pending: boolean;
};

function ViewFooter(p: FooterProps): ReactNode {
  if (p.a.account_status === 'deleted')
    return <ArchivedActions onRestore={p.onRestore} />;
  return (
    <ViewActions
      onEdit={p.onEdit}
      onArchive={p.onArchive}
      onReset={p.onReset}
      onStreakReset={p.onStreakReset}
      onUploadPhoto={p.onUploadPhoto}
      onVacation={p.onVacation}
    />
  );
}

export function DetailFooter(p: FooterProps): ReactNode {
  const bar = { onCancel: p.onCancel, pending: p.pending };
  if (p.mode === 'archive')
    return <ArchiveBar {...bar} onConfirm={p.onConfirmArchive} />;
  if (p.mode === 'restore')
    return <RestoreBar {...bar} onConfirm={p.onConfirmRestore} />;
  if (p.mode === 'reset-confirm')
    return <ResetConfirmBar {...bar} onConfirm={p.onConfirmReset} />;
  if (p.mode === 'reset-reveal')
    return <ResetReveal pwd={p.tempPwd} onClose={p.onCancel} />;
  if (p.mode === 'streak-reset-confirm')
    return <StreakResetBar {...bar} onConfirm={p.onConfirmStreakReset} />;
  if (p.mode === 'photo-upload')
    return <VerificationPhotoBar memberId={p.a.id} onClose={p.onCancel} />;
  if (p.mode === 'vacation')
    return <VacationBar a={p.a} onClose={p.onCancel} />;
  if (p.mode === 'status-edit')
    return <StatusEditBar a={p.a} onClose={p.onCancel} />;
  return <ViewFooter {...p} />;
}
